import { Badge } from '../ui/Badge';

interface StatCardProps {
  label: string;
  value: string;
  delta?: string | undefined;
  tone?: 'default' | 'good' | 'bad';
}

export function StatCard({ delta, label, tone = 'default', value }: StatCardProps) {
  const badgeTone = tone === 'good' ? 'success' : tone === 'bad' ? 'danger' : null;

  return (
    <div className="min-w-0 rounded border border-border bg-surface p-4">
      <div className="text-sm text-text-muted">{label}</div>
      {badgeTone ? (
        <Badge
          className="mt-2 max-w-full whitespace-nowrap"
          size="lg"
          tone={badgeTone}
          title={value}
        >
          <span className="min-w-0 truncate">{value}</span>
        </Badge>
      ) : (
        <div className="mt-2 truncate text-2xl font-semibold tabular-nums" title={value}>
          {value}
        </div>
      )}
      {delta ? <div className="mt-1 text-sm text-text-muted">{delta}</div> : null}
    </div>
  );
}
